// extracted by mini-css-extract-plugin
export var container = "_3o-1";
export var editor = "_3o-2";
export var resizable = "_3o-3";
export var wrapper = "_3o-0";